export default {
  datePicker__formControl_iconHover: {
    display: 'flex',
    border: 'none',
    padding: '0',
    position: 'relative',
  },
  datePicker__formControl_iconHover_input: {
    background: 'transparent',
    padding: '0.625rem',
    width: '100%',
    '&:active': {
      borderColor: '#006fcf',
    },
    '&:focus': {
      borderColor: '#006fcf',
    },
    '&:active ~ button': {
      color: '#006fcf',
      borderColor: '#006fcf',
      fontFamily: '"dls-icons-2.24.2"',
      content: '""',
      lineHeight: '1',
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
    },
    '&:focus ~ button': {
      color: '#006fcf',
      borderColor: '#006fcf',
      fontFamily: '"dls-icons-2.24.2"',
      content: '""',
      lineHeight: '1',
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
    },
  },
};
